
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_758_9317)"}},[_c('path',{attrs:{"d":"M3.14 2.24h9.72a2.34 2.34 0 012.336 2.208l.004.132v6.84a2.34 2.34 0 01-2.207 2.336l-.133.004H3.14a2.34 2.34 0 01-2.336-2.207L.8 11.42V4.58a2.34 2.34 0 012.208-2.336l.132-.004zm10.98 3.869L8.252 9.197a.54.54 0 01-.434.031l-.07-.03L1.88 6.11v5.311a1.26 1.26 0 001.156 1.256l.104.004h9.72a1.26 1.26 0 001.256-1.157l.004-.103V6.109zM12.86 3.32H3.14a1.26 1.26 0 00-1.256 1.156l-.004.104v.309L8 8.109l6.12-3.22V4.58a1.26 1.26 0 00-1.157-1.256l-.103-.004z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_758_9317"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.8 .8)","d":"M0 0h14.4v14.4H0z"}})])])])
          )
        }
      }
    